import { getApi } from "./util/getApi";

const fetchURL = process.env.REACT_APP_API_URL + "/user";
const api = getApi(fetchURL);

export const getUserRecommendations = () =>
  api
    .get("/recommendedUsersbyCauses", {})
    .then((response) => {
      console.log("getUserRecommendations-response", response);
      return response;
    })
    .catch((error) => {
      console.error("Error fetching getUserRecommendations:", error);
      throw error;
    });
